import { useGetOrganizationInvites } from '../../http/hooks.ts'
import { useOrgAuth } from '../../OrgAuthProvider.ts'
import { IInvite } from '../../services/nextpeakClient'
import Loader from '../../common/Loader'
import { getMe } from '../../MeProvider.ts'
import { useModal } from '../../components/modals/useModal.ts'
import { Page, PageProps } from '../../layout/Page.tsx'
import Table, { validateTableProps } from '../../newComponents/Table/index.tsx'
import { TableDataCell, TableHeaderCell } from '../../newComponents/Table/Cell.tsx'
import Card from '../../newComponents/Card/Card.tsx'
import { Button } from '../../newComponents/Button/Button.tsx'
import { useNextPeakClient } from '../../services/nextpeakClient/clientProvider.tsx'

const InviteTable = ({ invites }: { invites: IInvite[] }) => {
	const tableProps = validateTableProps(
		[
			{
				key: 'email',
				content: <TableHeaderCell>Email</TableHeaderCell>,
			},
			{
				key: 'status',
				content: <TableHeaderCell>Status</TableHeaderCell>,
			},
			{
				key: 'action',
				content: <TableHeaderCell>Status</TableHeaderCell>,
			},
		] as const,
		invites.map((invite) => {
			const inviteFlowFinished = invite.inviteStatus === 'Accepted' || invite.inviteStatus === 'Declined'

			return {
				email: <TableDataCell>{invite.email}</TableDataCell>,
				status: <TableDataCell>{invite.inviteStatus}</TableDataCell>,
				action: (
					<TableDataCell>
						<Button size="sm" color="secondary" disabled={inviteFlowFinished}>
							Resend
						</Button>
					</TableDataCell>
				),
			}
		})
	)

	return (
		<Card>
			<Table {...tableProps} />
		</Card>
	)
}

const pageProps: PageProps = {
	title: 'Invites',
	breadcrumbs: 'Invites',
}

const InvitesWithOrgContext = ({ activeOrganizationId }: { activeOrganizationId: string }) => {
	const me = getMe()
	const { onOpen } = useModal('CreateInviteModal')
	const client = useNextPeakClient()
	const { data, isLoading } = useGetOrganizationInvites(client, { organizationId: activeOrganizationId })

	const iamManager = me.organizationRoles.includes('manager')
	const iamAdmin = me.organizationRoles.includes('admin')

	const iCanInvite = iamManager || iamAdmin

	return (
		<Page {...pageProps}>
			<div>
				{isLoading && <Loader />}
				{!isLoading && data && (
					<>
						{iCanInvite && (
							<div className="flex justify-end mb-3">
								<Button size="sm" color="secondary" onClick={() => onOpen({ organizationId: activeOrganizationId })}>
									Invite
								</Button>
							</div>
						)}
						<InviteTable invites={data} />
					</>
				)}
			</div>
		</Page>
	)
}

const InvitesList = () => {
	const {
		authOrgUser: { orgId },
	} = useOrgAuth()

	if (!orgId) {
		return (
			<Page {...pageProps}>
				<div className="flex flex-col gap-10">
					<div>You need to select an active organization first</div>
				</div>
			</Page>
		)
	}

	return <InvitesWithOrgContext activeOrganizationId={orgId} />
}

export default InvitesList
